import { render, staticRenderFns } from "./Wait.vue?vue&type=template&id=739e72f6&scoped=true"
import script from "./Wait.vue?vue&type=script&scoped=true&lang=js"
export * from "./Wait.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./Wait.vue?vue&type=style&index=0&id=739e72f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739e72f6",
  null
  
)

export default component.exports